export default (obj => obj && obj.__isYupSchema__);